:host {
  --icon-color: currentcolor;
  --icon-size: 100%;
  display: flex;
}

:host svg {
  fill: var(--icon-color);
  width: var(--icon-size);
  height: var(--icon-size);
}
